import React from 'react'
import Logo from 'components/Logo'
import logo from '../assets/images/PG_new_logo.png';



type Postion = "content-top" | "content-center" | "content-bottom";
type Variant = "label" | "actions"
interface IHeader {
    children?: JSX.Element;
    postion?: Postion;
    variant?: Variant;
    onLogoClick?: Function

}
export default function Header(props: IHeader) {
    const { children, variant, postion } = props
    const onLogoClick = () => {
        if (props.onLogoClick) {
            props.onLogoClick()
        }
    }
    return (
        <div className="header">
            <div className="logo-container cursor-pointer" onClick={onLogoClick}>
                {/* <Logo /> */}
                <img src={logo} height={51.88} width={203.68} />
            </div>
            <div className={postion}>
                {children}
            </div>
        </div>
    )
}


Header.defaultProps = {
    children: <p></p>,
    postion: "content-top"
}